/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { defineComponent } from 'vue';
import props from './props.mjs';

var _DescriptionsItem = defineComponent({
  name: "TDescriptionsItem",
  props: props
});

export { _DescriptionsItem as default };
//# sourceMappingURL=descriptions-item.mjs.map
